export function validatePassword(password) {
  if (typeof password !== "string" || password.length < 8) {
    return "La contraseña debe tener al menos 8 caracteres.";
  }
  if (!/[A-Z]/.test(password)) {
    return "Añade al menos una letra mayúscula.";
  }
  if (!/[a-z]/.test(password)) {
    return "Añade al menos una letra minúscula.";
  }
  if (!/[0-9]/.test(password)) {
    return "Añade al menos un número.";
  }
  return "";
}
